var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.43,
    height: 16.53,
    viewBox: "0 0 12.43 16.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#767571;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11.71,3.77c-.02-.26-.23-.46-.49-.46h-1.53c-.12-1.84-1.64-3.31-3.52-3.31S2.78,1.47,2.66,3.31H1.21c-.26,0-.48,.2-.49,.46L0,14.45c-.04,.54,.15,1.07,.52,1.46,.37,.39,.89,.62,1.43,.62H10.48c.54,0,1.06-.23,1.43-.62s.56-.93,.52-1.46l-.71-10.68ZM6.17,.99c1.33,0,2.41,1.02,2.53,2.32H3.65c.12-1.3,1.2-2.32,2.53-2.32Zm5.01,14.25c-.18,.2-.43,.3-.7,.3H1.95c-.27,0-.52-.11-.7-.3-.18-.2-.28-.45-.26-.72L1.67,4.3h.96v1.05c0,.27,.22,.5,.49,.5s.49-.22,.49-.5v-1.05h5.1v1.05c0,.27,.22,.5,.49,.5s.49-.22,.49-.5v-1.05h1.04l.68,10.21c.02,.27-.07,.52-.26,.72Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/Bag.e11d05cc2c42658e33288e770a771a33.svg";
export { ForwardRef as ReactComponent };